import { Router, RouterConfigOptions } from '@angular/router';
import { RouterConfigService, staticImplements } from '@tdwb/core';

@staticImplements<RouterConfigService<AppNgRouterConfig, Router>>()
export class AppNgRouterConfig {
  static configure(): RouterConfigOptions {
    return {}
  }

  static configureTrace(): void {

  }

  static configureHelp(): void {

  }

  static configureSerializers(): void {

  }

  static configureBaseRoutes(): void {

  }

  static configureErrorHandler(): void {

  }

  static configureTransitionHooks(): void {

  }
}
